module.exports = __webpack_public_path__ + "worldexpo-1.jpg?6592e6f3460bbda285610416227a43c7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/worldexpo-1.jpg
// module id = 275
// module chunks = 0